<template>
	<div class="m-index" id="m-index">
		<div class="m-index-bg" :class="{'sc-red': isSCIOS}"></div>
		<section class="m-head u-pl32 u-pr32">
			<div class="m-head-first u-pt20">
				<img class="m-head-first-img" src="../../assets/images/head.png" alt="#">
				<span class="g-fs28" s-cr="#FFFFFF" f-font-PFR @click="goUnderstand">详细了解如何通过指数估值投资基金<img src="../../assets/images/allow-right-black.png" alt="#"></span>
			</div>
			<div class="m-head-second" v-if="false">
				<hxm-h5-video
					ref="hxmH5Video"
					:options="options"
					@on-video-play="onVideoPlay"
      				@on-video-pause="onVideoPause"
				>
				</hxm-h5-video>
			</div>
			<div class="m-index-slider">
				<slider orientation="X" :time="5000" v-if="recommendMeList && recommendMeList.length > 0" >
					<slider-item v-for="(list, index) in recommendMeList" :key="index" :controlClick="false">
						<div class="m-head-third" @click="goDetail(index, list.fundCode)">
							<h3 f-font-PFM class="f-bold f-ellipsis">{{list.fundName || list.name || '--'}}</h3>
							<p f-font-PFR>估值比过去<span>{{list.evaluateRate | formatProfit(true)}}</span>的时间低</p>
							<fund-progress :rate="list.evaluateRate"></fund-progress>
							<div class="m-detail-btn" f-font-PFM>查看详情</div>
						</div>
					</slider-item>
				</slider>
			</div>
			
		</section>
		<section class="m-rank" :class="{'margin-rank': recommendMeList && recommendMeList.length === 1}">
			<header>
				<span f-font-PFM>估值排行</span>
				<span f-font-PFR></span>
			</header>
			<div class="m-rank-des" s-cr="#999999" f-font-PFR>
				<span>适用</span>该指数估值的主要指标
			</div>
			<fund-table v-if="initAllMeList && initAllMeList.length > 0" :allMeList="allMeList" :initAllMeList="initAllMeList"></fund-table>
		</section>
		<interval class="g-mt40"></interval>
		<foot :explain="true"></foot>
		<fund-mask v-if="showFirst" @changeFirst="changeFirst" @changeInitshare="changeInitshare" :initAllMeList="initAllMeList"></fund-mask>
	</div>
</template>

<script>
	import Foot from "@/components/Footer";
	import FundProgress from "@/components/Progress";
	import FundTable from "@/components/Table";
	import Slider from 'ijijin-view/vue/Slider';
	import SliderItem from 'ijijin-view/vue/SliderItem';
	import Interval from "@/components/Interval";
	import FundMask from './mask.vue';
	import { fetchIndexAll, getTime } from '@/assets/js/fetchData';
	import { getTimeDate, config } from '@/assets/js/common';
	import { initShare, changeTitleBar } from '@/assets/js/fn.js';
	import { reportError } from '@/utils/monitor.js'
    export default {
		name: "index",
		components: {
			Foot,
			FundProgress,
			FundTable,
			Slider,
			SliderItem,
			FundMask,
			Interval
		},
        data () {
            return {
				options: {
					title: '',
					videoType: 'record',
					sources: [],
					autoplay: false,
					poster: '',
					aspectRatio: '16:9',
					controls: true
				},
				allMeList: [],
				initAllMeList: [],
				recommendMeList: [],
				time: '',
				showFirst: false,
				isSCIOS: false
			}
        },
		computed: {
		},
		methods: {
			changeInitshare() {
				const _this = this;
				if (_.urlInfo.sys === 'ths') {
					let timer = setTimeout(() => {
						initShare({
							callback: () => {
								document.body.style.overflow = 'hidden';
								_this.showFirst = true;
							}
						});
						clearTimeout(timer); 
					}, 100);      
				}
			},
			changeFirst(val) {
				this.showFirst = val;
				if (this.showFirst) {
					document.body.style.overflow = 'hidden';
				} else {
					document.body.style.overflow = 'auto';
				}
			},
			onVideoPlay() {
				_.log().clickStat('video');
			},
			onVideoPause() {
			},
			goUnderstand() {
				_.log().jumpPageStat('understand', 'seat_null');
				let url = 'https://fund.10jqka.com.cn/ifundapp_app/public/ruanWen/zhishuguzhibiao.html';
				if (_.urlInfo.sys === 'ths') {
					location.href = `client.html?action=ymtz^url=${url}^webid=2804^mode=new`;
				} else {
					_.jump().topage(url);
				}
				
			},
			goDetail(num, code) {
				num = Number(num) + 1;
				_.log().jumpPageStat(`tuijian.${num}`, 'seat_null');
				let url = `https://${config.testDev ? 'test' : ''}fund.10jqka.com.cn/${_.urlInfo.sys === 'ths' ? 'scym_scsy' : 'ifundapp_app'}/public/sf/indexValuation/dist/detail$FF330A.html?code=${code}#/`;
				if (_.urlInfo.sys === 'ths') {
					location.href = `client.html?action=ymtz^url=${url}^webid=2804^mode=new`;
				} else {
					_ && _.jump().topage(url, '指数估值详情');
				}
			},
			_fetchIndexAll() {
				fetchIndexAll().then((res) => {
					const { allMeList, recommendMeList } = res;
					this.allMeList = [];
					this.recommendMeList = [];
					this.initAllMeList = [];
					let lowData = [], middleData = [], highData = [], otherData = [];
					allMeList && allMeList.forEach((item) => {
						this.allMeList.push({...item});
						if (item.pe !== null && item.pe !== undefined) {
							switch(item.evaluateStatus) {
								case '0':
									lowData.push({...item});
									break;
								case '1':
									middleData.push({...item});
									break;
								case '2':
									highData.push({...item});
									break;
								default:
									otherData.push({...item});
									break;
							}
						} else {
							otherData.push({...item});
						}
					})
					if (lowData.length > 1) {
						lowData.sort((a, b) => {
							return Number(a.pe) - Number(b.pe)
						})
					}
					if (middleData.length > 1) {
						middleData.sort((a, b) => {
							return Number(a.pe) - Number(b.pe)
						})
					}
					if (highData.length > 1) {
						highData.sort((a, b) => {
							return Number(a.pe) - Number(b.pe)
						})
					}
					this.initAllMeList = [...lowData, ...middleData, ...highData, ...otherData];
					recommendMeList && recommendMeList.forEach((item) => {
						item.evaluateProgress = {
							status: item.evaluateStatus,
							rate: Number(item.evaluateRate)
						};
						this.recommendMeList.push({...item});
					})
				}).catch((e) => {
					reportError('js', 'error fetchIndexAll promise', e);
					console.log(e);
					this.$toast('网络错误，请稍后再试');
				})
			},
			_getTime() {
				getTime().then((res) => {
					this.time = getTimeDate(res * 1000) || '';
				}).catch((e) => {
					reportError('js', 'error getTime promise', e);
					console.log(e);
					this.$toast('网络错误，请稍后再试');
				})
			}
		},
		mounted() {
			console.log('0.1.4');
			const _this = this;
			
			changeTitleBar('#FF330A');
			if (_.urlInfo.sys === 'ths' && _.platform.osInfo === 'iphone') {
				this.isSCIOS = true;
			}
			this._fetchIndexAll();
			initShare({
				callback: () => {
					_.log().clickStat('share');
					document.body.style.overflow = 'hidden';
					_this.showFirst = true;
				}
			});

			registerWebListener('onShow', function(){
				initShare({
					callback: () => {
						_.log().clickStat('share');
						document.body.style.overflow = 'hidden';
						_this.showFirst = true;
					}
				});
			});
		},
    }
</script>

<style lang="less" scoped>
.m-index {
	position: relative;
	.m-index-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 450px;
		background-image: linear-gradient(1deg, rgba(255,147,55,0.00) 0%, #FF330A 66%);
		z-index: -1;
		&.sc-red {
			background-image: linear-gradient(1deg, rgba(255,147,55,0.00) 0%, #e83030 66%);
		}
	}
	.m-head {
		.m-head-first {
			margin-bottom: 48px;
			.m-head-first-img {
				width: 428px;
				height: 60px;
				margin: 36px 0 16px;
			}
			span {
				display: flex; 
				align-items: center;
				line-height: 44px;
				img {
					width: 16px;
					height: 24px;
					margin-left: 8px;
				}
			}
		}
		.m-head-second {
			width: 686px;
			height: 386px;
			background: rgba(0,0,0,0.45);
			border-radius: 16px;
			margin-bottom: 32px;
			 .hxm-video-container {
				height: 386px;
				border-radius: 16px;
				.hxm-video-player-container {
					height: 386px;
					border-radius: 16px;
				}
			}
			video {
				height: 100%;
				border-radius: 16px;
			}
		}
		.m-head-third {
			box-sizing: border-box;
			width: 100%;
			padding: 32px 24px 0;
			background: #FFFFFF;
			border: 1px solid #F6F6F6;
			box-shadow: 0px 0px 24px 0px rgba(0,0,0,0.04);
			border-radius: 16px;
			text-align: center;
			h3 {
				font-size: 36px;
				line-height: 50px;
				color: rgba(0,0,0,0.80);
			}
			p {
				font-size: 24px;
				color: #999999;
				line-height: 38px;
				font-weight: 400;
				margin: 8px 0 32px;
				span {
					color: rgba(0,0,0);
				}
			}
			.m-detail-btn {
				margin: 32px auto;
				width: 451px;
				height: 80px;
				line-height: 80px;
				background: #FF330A;
				border-radius: 16px;
				font-size: 28px;
				color: #FFFFFF;
				letter-spacing: 0;
				font-weight: bold;
			}
		}
		.m-index-slider /deep/ .vu-slider {
			max-height: 450px!important;
			height: 450px;
			border-radius: 16px;
			.vu-control-list {
				padding: 0 0 36px 0;
				.u-icon_il {
					width: 8px;
					height: 8px;
					margin-left: 8px;
					background: #E6E6E6;
					&.active {
						background: #FF330A;
					}
				}
			}
		}
	}
	.m-rank {
		margin-top: 10px;
		header {
			display: flex;
			justify-content: space-between;
			padding: 0 32px;
			span {
				line-height: 50px;
				letter-spacing: 0;
				&:first-child {
					font-size: 36px;
					color: #323232;
					font-weight: bold;
				}
				&:last-child {
					font-size: 28px;
					color: #B3B3B3;
					font-weight: 400;
				}
			}
		}
		.m-rank-des {
			margin: 24px 0 4px 0;
			font-size: 28px;
			line-height: 32px;
			font-weight: 400;
			padding-left: 32px;
			span {
				display: inline-block;
				padding: 0 4px;
				font-size: 24px;
				height: 32px;
				line-height: 32px;
				background: #F6F6F6;
				border: 1px solid #E6E6E6;
				border-radius: 8px;
				margin-right: 8px;
			}
		}
		&.margin-rank {
			margin-top: -28px;
		}
	}
}
.iphonex .m-index {
	padding-bottom: 32px;
}
</style>
